import {useEffect, useState} from 'react'

const UNSUPPORTED_DEVICE_ERROR_MESSAGE = 'Browser does not support Web Share API'
const SHARING_ERROR_MESSAGE = 'Error sharing'

const useShareApi = () => {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const canShare = isMounted && Boolean(window.navigator && window.navigator.share)

  const share = ({title, text, url}) => {
    if (!canShare) return Promise.reject(new Error(UNSUPPORTED_DEVICE_ERROR_MESSAGE))

    const shareProperties = {
      ...(title && {title}),
      ...(text && {text}),
      ...(url && {url})
    }

    return navigator
      .share(shareProperties)
      .then(() => Promise.resolve(true))
      .catch(error => Promise.reject(new Error(SHARING_ERROR_MESSAGE, error)))
  }

  return {canShare, share}
}

export {useShareApi}
